import { Button } from '@salesforce/design-system-react';
import React from 'react';
import Defi from '../../assets/images/login/Defi.png';
import './login.css';

const LoginRight = () => {
  return (
    <React.Fragment>
      <div className="slds-col slds-size_1-of-1 slds-large-size_6-of-12 custom_slds_bkg_right">
        <div className="sdls_login_explr_box">
          <div className="sdls_global_block_view sdls_login_explr_text slds-m-bottom_small">
            <div>Explore the Features</div>
            <div>of the Portfolio Manager</div>
          </div>
          <div className="sdls_global_block_view sdls_login_explr_small_text slds-m-bottom_x-small">
            <div>Sign in to Explore the Features</div>
            <div>of the Portfolio Manager</div>
          </div>
          {/* <div className="slds-m-bottom_small">
            <Button
              style={{
                width: 130,
                height: 32,
                marginTop: 10,
                marginBottom: 30,
              }}
              className="sdls_btn_explr_text"
            >
              Explore Now
            </Button>
          </div> */}
          <div
            style={{
              backgroundImage: `url('${Defi}')`,
              backgroundRepeat: 'no-repeat',
              height: 'calc(100vh - 350px)',
              backgroundSize: 'cover',
              marginTop: '35px',
            }}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default LoginRight;
